export const movies = [
  {
    id: "mv-001",
    title: "春日暖阳",
    type: "电视剧",
    category: "都市情感",
    region: "中国",
    year: 2024,
    director: "林一杋",
    actors: ["杨紫", "许凯", "李沐宸"],
    episodes: 40,
    rating: 8.7,
    views: 3280,
    updateStatus: "更新至32集",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20film%20poster%20background%20with%20soft%20pink%20cherry%20blossoms%20and%20warm%20golden%20light%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20palette%2C%20high%20detail%2C%20harmonious%20editorial%20mood&width=400&height=600&seq=love-cv-01&orientation=portrait",
    synopsis: "在南方老城一条梧桐树掩映的小街上，独立摄影师苏怡与植物学讲师周野生因一株深夜盛开的樱花树意外相遇。两人从针锋相对到彼此治愈，用四季更迭写下一段温柔的爱情。当旧日伤痕再次浮现，他们能否守住这份来之不易的暖阳？",
    highlights: [
      "老城区梧桐树下的慢节奏治愈爱情",
      "细腻自然的日常烟火气与双向奔赴",
      "春日樱花、夏夜蝉鸣的四季影像美学",
    ],
    tags: ["都市", "治愈", "双向奔赴"],
  },
  {
    id: "mv-002",
    title: "心跳处方",
    type: "电视剧",
    category: "都市情感",
    region: "中国",
    year: 2023,
    director: "顾清舟",
    actors: ["白鹿", "张凌赫", "周澄奥"],
    episodes: 30,
    rating: 8.3,
    views: 2560,
    updateStatus: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20art%20with%20rain%20on%20a%20window%20and%20pink%20umbrella%20silhouette%2C%20soft%20pastel%20rose%20tones%2C%20dreamy%20warm%20lighting%2C%20minimal%20elegant%20composition%2C%20no%20text%2C%20cohesive%20editorial%20mood%2C%20high%20detail&width=400&height=600&seq=love-cv-02&orientation=portrait",
    synopsis: "心脏外科医生沈知夏与号称“冷面”的急诊科主任陆时晏，是医院里出了名的死对头。一场连环急诊让两人被迫联手，也在无数次争分夺秒的抢救中读懂了彼此的柔软。原来这世上最好的处方，是彼此的心跳。",
    highlights: [
      "医生职场与情感的细腻交织",
      "从针锋相对到并肩作战的宿敌感",
      "急诊室里的高密度情绪张力",
    ],
    tags: ["医疗", "职场", "甜宠"],
  },
  {
    id: "mv-003",
    title: "我们的十年",
    type: "电视剧",
    category: "青春校园",
    region: "中国",
    year: 2022,
    director: "苏念",
    actors: ["谭松韵", "白敬亭", "张艺上"],
    episodes: 36,
    rating: 8.0,
    views: 1980,
    updateStatus: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20a%20sunlit%20empty%20classroom%20at%20sunset%20with%20warm%20pink%20glow%2C%20nostalgic%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20palette%2C%20high%20detail%2C%20editorial%20mood&width=400&height=600&seq=love-cv-03&orientation=portrait",
    synopsis: "高中同桌程曦与江野有一个约定：无论走多远，十年后都要回到老操场再见一面。十年间他们错过、重逢、又相爱，把青春里所有的甜与涩都酿成了成年后重新出发的勇气。",
    highlights: [
      "跨越十年的青春成长群像",
      "重逢系爱情的真实与心动",
      "老操场与旧信物构成的记忆锚点",
    ],
    tags: ["青春", "成长", "重逢"],
  },
  {
    id: "mv-004",
    title: "南风知我意",
    type: "电视剧",
    category: "都市情感",
    region: "中国",
    year: 2023,
    director: "沈书",
    actors: ["赵露思", "陈哲远", "王弘毅"],
    episodes: 38,
    rating: 8.1,
    views: 2240,
    updateStatus: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20a%20golden%20wheat%20field%20swaying%20in%20warm%20southern%20breeze%2C%20soft%20pink%20sunset%20sky%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20palette%2C%20high%20detail&width=400&height=600&seq=love-cv-04&orientation=portrait",
    synopsis: "建筑师温言回到故乡小镇接手一座老宅改造，遇见了守着老书店的周知意。南风吹过的大院里，两个人一边修补旧房子，一边修补彼此心里的裂缝。有些爱，不必说出口，风会懂。",
    highlights: [
      "故乡小镇的慢生活治愈气息",
      "老宅与旧书店勾勒的怀旧浪漫",
      "克制而深情的暗恋式表达",
    ],
    tags: ["治愈", "小镇", "暗恋"],
  },
  {
    id: "mv-005",
    title: "以爱为营",
    type: "电视剧",
    category: "都市情感",
    region: "中国",
    year: 2023,
    director: "何叙",
    actors: ["白鹿", "王鹤棣", "魏哲鸣"],
    episodes: 36,
    rating: 7.8,
    views: 3100,
    updateStatus: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20a%20city%20rooftop%20at%20night%20with%20warm%20bokeh%20lights%20and%20pink%20glow%2C%20modern%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20rose%20and%20cream%20palette%2C%20high%20detail&width=400&height=600&seq=love-cv-05&orientation=portrait",
    synopsis: "财经记者郑书意与科技公司创始人时宴，在一次采访交锋中结下“梁子”。职场上的步步为营，情场里的欲擒故纵，两个聪明人把感情打成了一场精妙绝伦的营战，却谁也没能赢过心动。",
    highlights: [
      "高智商男女主的职场博弈式恋爱",
      "势均力敌的暧昧拉扯感",
      "都市职场与情感线的双线并行",
    ],
    tags: ["职场", "博弈", "先婚后爱"],
  },
  {
    id: "mv-006",
    title: "迟到的告白",
    type: "电影",
    category: "爱情片",
    region: "中国",
    year: 2024,
    director: "韩舟",
    actors: ["周也", "刘昊然", "张宥浩"],
    episodes: 0,
    rating: 8.5,
    views: 1460,
    updateStatus: "正在热映",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20an%20airport%20reunion%20silhouette%20with%20soft%20pink%20morning%20light%20through%20glass%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20palette%2C%20high%20detail%2C%20editorial%20mood&width=400&height=600&seq=love-cv-06&orientation=portrait",
    synopsis: "毕业那年的那封告白信，被塞进了错误的书包。十年后，机场的一次偶遇让陈默和许诺不得不重新翻开那段没说出口的喜欢。有些告白会迟到，但只要说出口，就不算太晚。",
    highlights: [
      "一封错放的信牵出的十年遗憾",
      "机场重逢的克制与汹涌",
      "关于“错过与勇敢”的温柔命题",
    ],
    tags: ["遗憾", "重逢", "治愈"],
  },
  {
    id: "mv-007",
    title: "后来的我们",
    type: "电影",
    category: "爱情片",
    region: "中国",
    year: 2018,
    director: "刘若英",
    actors: ["井柏然", "周冬雨", "田壮壮"],
    episodes: 0,
    rating: 8.6,
    views: 2780,
    updateStatus: "全片上线",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20a%20snowy%20winter%20train%20station%20platform%20with%20warm%20pink%20station%20lamps%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20palette%2C%20nostalgic%20editorial%20mood&width=400&height=600&seq=love-cv-07&orientation=portrait",
    synopsis: "北漂青年林见清和方小晓在出租屋里相爱、争吵、又走散。多年后春运的火车上，两人隔着人潮回望青春。后来的我们什么都有了，却没有了我们。",
    highlights: [
      "北漂岁月里真实得心疼的爱情",
      "春运火车与出租屋的时代记忆",
      "关于成长代价的深刻共鸣",
    ],
    tags: ["北漂", "成长", "遗憾"],
  },
  {
    id: "mv-008",
    title: "情书",
    type: "电影",
    category: "爱情片",
    region: "日本",
    year: 1995,
    director: "岩井俊二",
    actors: ["中山美穗", "柏原崇", "酒井美纪"],
    episodes: 0,
    rating: 9.1,
    views: 3520,
    updateStatus: "经典重映",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20a%20snowy%20mountain%20town%20with%20soft%20pink%20dawn%20light%20and%20a%20love%20letter%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20palette%2C%20quiet%20editorial%20mood&width=400&height=600&seq=love-cv-08&orientation=portrait",
    synopsis: "一封寄往天国的信，意外寄到了同名同姓的女孩手中。在往来书信里，一段被时光尘封的青春暗恋缓缓浮现。原来那个沉默的少年，曾用整个青春认真地喜欢过一个人。",
    highlights: [
      "教科书级的青春暗恋叙事",
      "雪国小镇与借书卡上的秘密",
      "跨越生死的温柔想念",
    ],
    tags: ["暗恋", "经典", "日影"],
  },
  {
    id: "mv-009",
    title: "你的婚礼",
    type: "电影",
    category: "爱情片",
    region: "中国",
    year: 2021,
    director: "韩天",
    actors: ["许光汉", "章若楠", "丁冠森"],
    episodes: 0,
    rating: 7.9,
    views: 2660,
    updateStatus: "全片上线",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20a%20seaside%20wedding%20arch%20with%20soft%20pink%20roses%20and%20golden%20hour%20light%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20palette%2C%20high%20detail&width=400&height=600&seq=love-cv-09&orientation=portrait",
    synopsis: "游泳特长生周潇齐与转校生尤咏慈相识于高中，一场跨越十五年的追逐就此开始。从校服到西装，他始终是那个奋不顾身的人，可有些爱情，终究只能以“你的婚礼”作结。",
    highlights: [
      "十五年校服到西装的追爱长跑",
      "青春与成年现实的双重对照",
      "高浓度泪点的告别式爱情",
    ],
    tags: ["青春", "追爱", "催泪"],
  },
  {
    id: "mv-010",
    title: "怦然心动",
    type: "电影",
    category: "爱情片",
    region: "欧美",
    year: 2010,
    director: "罗伯·莱纳",
    actors: ["玛德琳·卡罗尔", "卡兰·麦克奥利菲"],
    episodes: 0,
    rating: 9.0,
    views: 3980,
    updateStatus: "经典",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20a%20big%20sycamore%20tree%20on%20a%20hill%20at%20warm%20pink%20sunset%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20palette%2C%20nostalgic%20editorial%20mood&width=400&height=600&seq=love-cv-10&orientation=portrait",
    synopsis: "朱丽从七岁起就喜欢上了邻居男孩布莱斯，而布莱斯却一直想躲开她。当朱丽开始看见更大的世界，布莱斯才终于明白——那个总在梧桐树上眺望远方的女孩，有多珍贵。",
    highlights: [
      "双视角叙事下的青涩心动",
      "梧桐树与鸡蛋的成长隐喻",
      "关于“整体大于部分之和”的爱情观",
    ],
    tags: ["初恋", "成长", "经典"],
  },
  {
    id: "mv-011",
    title: "爱乐之城",
    type: "电影",
    category: "爱情片",
    region: "欧美",
    year: 2016,
    director: "达米恩·查泽雷",
    actors: ["瑞恩·高斯林", "艾玛·斯通", "约翰·传奇"],
    episodes: 0,
    rating: 8.9,
    views: 3410,
    updateStatus: "经典",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20a%20jazz%20piano%20under%20a%20purple%20pink%20night%20sky%20with%20city%20lights%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20rose%20and%20cream%20palette%2C%20high%20detail&width=400&height=600&seq=love-cv-11&orientation=portrait",
    synopsis: "在洛杉矶，落魄的爵士钢琴师塞巴斯汀遇见了屡屡试镜失败的演员米娅。他们互相鼓励着追逐梦想，也在梦想渐近时慢慢走远。一首《City of Stars》，唱尽了理想与爱情的取舍。",
    highlights: [
      "歌舞与光影交织的浪漫美学",
      "梦想与爱情的两难抉择",
      "结尾五分钟的“如果重来”蒙太奇",
    ],
    tags: ["歌舞", "梦想", "经典"],
  },
  {
    id: "mv-012",
    title: "四月物语",
    type: "电影",
    category: "爱情片",
    region: "日本",
    year: 1998,
    director: "岩井俊二",
    actors: ["松隆子", "田边诚一", "江口洋介"],
    episodes: 0,
    rating: 8.4,
    views: 1120,
    updateStatus: "经典",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20spring%20rain%20in%20a%20quiet%20countryside%20town%20with%20pink%20petals%20and%20soft%20light%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20palette%2C%20gentle%20editorial%20mood&width=400&height=600&seq=love-cv-12&orientation=portrait",
    synopsis: "为了追随暗恋的学长，少女榆野卯月独自来到东京读大学。四月的雨、旧书店、一把借来的红伞，构成了她整个春天的心事。这是一场安静得几乎没有对白的暗恋。",
    highlights: [
      "岩井俊二式的春日清新影像",
      "几乎无对白的细腻暗恋",
      "旧书店红伞的经典意象",
    ],
    tags: ["暗恋", "文艺", "日影"],
  },
  {
    id: "mv-013",
    title: "爱的迫降",
    type: "电视剧",
    category: "海外情感",
    region: "韩国",
    year: 2020,
    director: "李郑孝",
    actors: ["玄彬", "孙艺珍", "金正贤"],
    episodes: 16,
    rating: 9.0,
    views: 4200,
    updateStatus: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20a%20mountain%20paragliding%20sky%20with%20soft%20pink%20clouds%20and%20green%20fields%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20palette%2C%20high%20detail&width=400&height=600&seq=love-cv-13&orientation=portrait",
    synopsis: "韩国财阀千金尹世理在滑翔伞事故中意外迫降，被朝鲜军官李正赫发现。两个本不该相遇的人，在守护与危险中慢慢靠近。跨越界限的爱情，需要多大的勇气？",
    highlights: [
      "跨越南北界限的守护式爱情",
      "瑞士雪景与乡村烟火的浪漫对照",
      "玄彬孙艺珍的绝佳化学反应",
    ],
    tags: ["韩剧", "宿命", "治愈"],
  },
  {
    id: "mv-014",
    title: "太阳的后裔",
    type: "电视剧",
    category: "海外情感",
    region: "韩国",
    year: 2016,
    director: "李应福",
    actors: ["宋仲基", "宋慧乔", "晋久"],
    episodes: 16,
    rating: 8.6,
    views: 3860,
    updateStatus: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20a%20desert%20jeep%20on%20a%20golden%20dune%20at%20warm%20sunset%20with%20pink%20sky%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20palette%2C%20high%20detail&width=400&height=600&seq=love-cv-14&orientation=portrait",
    synopsis: "特战部队大尉刘时镇与外科医生姜暮烟，在战火纷飞的异国他乡相遇。一个以守护生命为使命，一个以保家卫国为职责。当爱情降临在枪炮之间，他们学会了对彼此的信仰。",
    highlights: [
      "军人与医生的信念感爱情",
      "异国战地的炽热与浪漫",
      "势均力敌的成年人之恋",
    ],
    tags: ["韩剧", "军旅", "热血"],
  },
  {
    id: "mv-015",
    title: "孤单又灿烂的神：鬼怪",
    type: "电视剧",
    category: "海外情感",
    region: "韩国",
    year: 2016,
    director: "李应福",
    actors: ["孔刘", "金高银", "李栋旭"],
    episodes: 16,
    rating: 9.2,
    views: 4450,
    updateStatus: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20candlelight%20and%20first%20snow%20in%20a%20quiet%20winter%20street%20with%20soft%20pink%20glow%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20palette%2C%20high%20detail&width=400&height=600&seq=love-cv-15&orientation=portrait",
    synopsis: "活了九百多年的不死鬼怪金侁，只有在遇到“鬼怪新娘”时才能结束永生。当注定成为他新娘的少女池恩倬出现，一场关于命运、守护与告别的奇幻爱情就此展开。",
    highlights: [
      "奇幻设定下宿命般的爱情",
      "初雪与荞麦田的唯美名场面",
      "关于生与死、记住与遗忘的哲思",
    ],
    tags: ["韩剧", "奇幻", "宿命"],
  },
  {
    id: "mv-016",
    title: "东京爱情故事",
    type: "电视剧",
    category: "海外情感",
    region: "日本",
    year: 1991,
    director: "永山耕三",
    actors: ["铃木保奈美", "织田裕二", "有森也实"],
    episodes: 11,
    rating: 8.9,
    views: 1560,
    updateStatus: "经典",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20a%20tokyo%20street%20at%20dusk%20with%20soft%20pink%20lamps%20and%20light%20rain%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20palette%2C%20nostalgic%20editorial%20mood&width=400&height=600&seq=love-cv-16&orientation=portrait",
    synopsis: "从爱媛来到东京的完治，遇见了永远笑得灿烂的赤名莉香。她勇敢、直接、毫无保留地爱着他，而他却始终望向另一个人。那个在车站回头挥手的笑容，成了一代人的意难平。",
    highlights: [
      "一代人心中的意难平神作",
      "莉香式毫无保留的勇敢",
      "九十年代东京街头的怀旧感",
    ],
    tags: ["日剧", "经典", "意难平"],
  },
  {
    id: "mv-017",
    title: "悠长假期",
    type: "电视剧",
    category: "海外情感",
    region: "日本",
    year: 1996,
    director: "永山耕三",
    actors: ["木村拓哉", "山口智子", "竹野内丰"],
    episodes: 11,
    rating: 8.8,
    views: 1340,
    updateStatus: "经典",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20a%20summer%20beach%20at%20warm%20sunset%20with%20soft%20pink%20sky%20and%20gentle%20waves%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20palette%2C%20high%20detail&width=400&height=600&seq=love-cv-17&orientation=portrait",
    synopsis: "婚礼当天被逃婚的南，与被公司雪藏的钢琴家濑名，阴差阳错成了室友。两个人都在人生的低谷，却在彼此的陪伴里，把这段无所事事的日子过成了“悠长假期”。",
    highlights: [
      "低谷期互相治愈的成人爱情",
      "木村拓哉的黄金时代经典",
      "夏天、海边与钢琴的治愈氛围",
    ],
    tags: ["日剧", "治愈", "经典"],
  },
  {
    id: "mv-018",
    title: "罗马假日",
    type: "电影",
    category: "爱情片",
    region: "欧美",
    year: 1953,
    director: "威廉·惠勒",
    actors: ["奥黛丽·赫本", "格里高利·派克", "埃迪·艾伯特"],
    episodes: 0,
    rating: 9.1,
    views: 3250,
    updateStatus: "经典",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20a%20vintage%20vespa%20on%20a%20rome%20street%20with%20soft%20pink%20afternoon%20light%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20palette%2C%20nostalgic%20editorial%20mood&width=400&height=600&seq=love-cv-18&orientation=portrait",
    synopsis: "出逃的欧洲公主安妮在罗马街头邂逅了美国记者乔，两人度过了如梦似幻的一天。当身份揭晓，这段短暂而美好的相遇，最终只能定格成一场无法言说的假日。",
    highlights: [
      "赫本与派克的传世经典搭档",
      "罗马街头的浪漫一日游",
      "关于责任与克制的永恒之美",
    ],
    tags: ["经典", "公主", "罗马"],
  },
  {
    id: "mv-019",
    title: "乱世佳人",
    type: "电影",
    category: "爱情片",
    region: "欧美",
    year: 1939,
    director: "维克多·弗莱明",
    actors: ["费雯·丽", "克拉克·盖博", "奥利维娅·德哈维兰"],
    episodes: 0,
    rating: 9.3,
    views: 3020,
    updateStatus: "经典",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20a%20southern%20plantation%20mansion%20at%20warm%20pink%20sunset%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20palette%2C%20vintage%20editorial%20mood&width=400&height=600&seq=love-cv-19&orientation=portrait",
    synopsis: "南北战争的烽火中，骄傲的南方庄园小姐斯嘉丽与浪子白瑞德上演了一场爱恨纠缠。当一切随风而逝，她依然倔强地相信：明天又是新的一天。",
    highlights: [
      "影史不朽的爱情史诗",
      "斯嘉丽与白瑞德的爱恨与错过",
      "“明天又是新的一天”的坚韧力量",
    ],
    tags: ["史诗", "经典", "乱世"],
  },
  {
    id: "mv-020",
    title: "傲慢与偏见",
    type: "电影",
    category: "爱情片",
    region: "欧美",
    year: 2005,
    director: "乔·怀特",
    actors: ["凯拉·奈特莉", "马修·麦克费登"],
    episodes: 0,
    rating: 8.7,
    views: 2880,
    updateStatus: "经典",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20an%20english%20countryside%20manor%20with%20misty%20dawn%20and%20soft%20pink%20light%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20palette%2C%20quiet%20editorial%20mood&width=400&height=600&seq=love-cv-20&orientation=portrait",
    synopsis: "伊丽莎白与达西，一个带着偏见，一个裹着傲慢。在一次次误解与试探后，他们终于放下了各自的铠甲。清晨薄雾中达西走来的那一幕，成为影史最浪漫的告白之一。",
    highlights: [
      "英伦田园中的古典浪漫",
      "从偏见到真心的经典弧线",
      "晨曦告白的影史名场面",
    ],
    tags: ["名著", "古典", "英伦"],
  },
  {
    id: "mv-021",
    title: "步步惊心",
    type: "电视剧",
    category: "古装情缘",
    region: "中国",
    year: 2011,
    director: "李国立",
    actors: ["刘诗诗", "吴奇隆", "郑嘉颖"],
    episodes: 35,
    rating: 8.4,
    views: 3460,
    updateStatus: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20ancient%20chinese%20palace%20lanterns%20with%20warm%20pink%20glow%20and%20silk%20curtains%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20palette%2C%20high%20detail&width=400&height=600&seq=love-cv-21&orientation=portrait",
    synopsis: "现代白领张晓意外穿越成清朝少女若曦，卷入了康熙九子夺嫡的漩涡。她深知情史结局，却无力改变命运。这段被历史洪流裹挟的爱情，从开始就写满了身不由己。",
    highlights: [
      "穿越设定下的宿命悲剧美",
      "九子夺嫡与儿女情长交织",
      "四爷与若曦的遗憾情深",
    ],
    tags: ["古装", "穿越", "虐恋"],
  },
  {
    id: "mv-022",
    title: "知否知否应是绿肥红瘦",
    type: "电视剧",
    category: "古装情缘",
    region: "中国",
    year: 2018,
    director: "张开宙",
    actors: ["赵丽颖", "冯绍峰", "朱一龙"],
    episodes: 73,
    rating: 8.6,
    views: 4150,
    updateStatus: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20a%20classical%20chinese%20mansion%20courtyard%20with%20plum%20blossoms%20and%20soft%20pink%20light%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20palette%2C%20high%20detail&width=400&height=600&seq=love-cv-22&orientation=portrait",
    synopsis: "盛家庶女盛明兰自幼藏起锋芒，在深宅大院里步步为营。她与顾廷烨从假意疏远到真心相许，一路相互扶持。这段始于算计、终于深情的姻缘，写尽了古代女子的智慧与坚韧。",
    highlights: [
      "宅斗与爱情并重的世情长卷",
      "明兰与顾二叔的守护式婚姻",
      "细腻考究的宋代生活美学",
    ],
    tags: ["古装", "宅斗", "成长"],
  },
  {
    id: "mv-023",
    title: "香蜜沉沉烬如霜",
    type: "电视剧",
    category: "古装情缘",
    region: "中国",
    year: 2018,
    director: "朱锐斌",
    actors: ["杨紫", "邓伦", "罗云熙"],
    episodes: 63,
    rating: 8.2,
    views: 3720,
    updateStatus: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20a%20peach%20blossom%20forest%20with%20falling%20petals%20and%20warm%20pink%20mist%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20palette%2C%20high%20detail%2C%20fantasy%20mood&width=400&height=600&seq=love-cv-23&orientation=portrait",
    synopsis: "花神之女锦觅因服下陨丹而不知情爱，与天帝之子旭凤恩怨纠缠三生。当陨丹碎裂，她才知道自己曾亲手毁掉最爱的人。这是一场跨越三世的甜与虐。",
    highlights: [
      "三世轮回的甜虐仙侠爱情",
      "葡萄与凤凰的经典CP",
      "唯美仙界与跌宕情劫",
    ],
    tags: ["仙侠", "古装", "虐恋"],
  },
  {
    id: "mv-024",
    title: "三生三世十里桃花",
    type: "电视剧",
    category: "古装情缘",
    region: "中国",
    year: 2017,
    director: "林玉芬",
    actors: ["杨幂", "赵又廷", "迪丽热巴"],
    episodes: 58,
    rating: 8.5,
    views: 4020,
    updateStatus: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20moonlight%20over%20a%20fantasy%20chinese%20palace%20with%20pink%20clouds%20and%20petals%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20palette%2C%20high%20detail&width=400&height=600&seq=love-cv-24&orientation=portrait",
    synopsis: "青丘女君白浅与天族太子夜华三生三世的爱恨纠葛。诛仙台一跃、东荒大泽重逢，前世的伤痛与今生的深情层层交叠，只为兑现那一句“愿有岁月可回首”。",
    highlights: [
      "三生三世轮回的仙侠虐恋",
      "诛仙台与十里桃林的经典意象",
      "杨幂赵又廷的传奇CP",
    ],
    tags: ["仙侠", "古装", "轮回"],
  },
  {
    id: "mv-025",
    title: "且试天下",
    type: "电视剧",
    category: "古装情缘",
    region: "中国",
    year: 2022,
    director: "尹涛",
    actors: ["杨洋", "赵露思", "张彬彬"],
    episodes: 40,
    rating: 7.6,
    views: 2640,
    updateStatus: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20an%20ancient%20battlefield%20at%20dusk%20with%20soft%20pink%20sky%20and%20banners%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20palette%2C%20epic%20editorial%20mood&width=400&height=600&seq=love-cv-25&orientation=portrait",
    synopsis: "江湖侠女白风夕与隐世公子丰兰息，于乱世中并肩而行。他们既是棋逢对手的知己，也是执手相望的恋人。当天下大势与个人情爱相撞，两人选择以真心共赴山河。",
    highlights: [
      "江湖与朝堂双线的势均力敌",
      "男女主并肩作战的携手感",
      "大气恢弘的东方美学",
    ],
    tags: ["古装", "江湖", "携手"],
  },
  {
    id: "mv-026",
    title: "暗恋橘生淮南",
    type: "电视剧",
    category: "青春校园",
    region: "中国",
    year: 2019,
    director: "沙漠",
    actors: ["胡一天", "胡冰卿", "张逸杰"],
    episodes: 24,
    rating: 7.7,
    views: 1860,
    updateStatus: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20a%20quiet%20school%20library%20with%20warm%20pink%20afternoon%20light%20through%20windows%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20palette%2C%20nostalgic%20editorial%20mood&width=400&height=600&seq=love-cv-26&orientation=portrait",
    synopsis: "从高一开始，洛枳就默默喜欢着盛淮南，把这段暗恋写进厚厚的日记。多年后两人在大学重逢，那些没说出口的心事，终于有了被看见的机会。",
    highlights: [
      "最真实细腻的青春暗恋",
      "日记与天台里的少女心事",
      "从校园到职场的漫长喜欢",
    ],
    tags: ["青春", "暗恋", "校园"],
  },
  {
    id: "mv-027",
    title: "致我们暖暖的小时光",
    type: "电视剧",
    category: "青春校园",
    region: "中国",
    year: 2019,
    director: "吴强",
    actors: ["邢菲", "林一", "唐晓天"],
    episodes: 24,
    rating: 8.4,
    views: 2320,
    updateStatus: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20a%20sunlit%20dormitory%20window%20with%20sheer%20curtains%20and%20soft%20pink%20morning%20light%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20palette%2C%20high%20detail&width=400&height=600&seq=love-cv-27&orientation=portrait",
    synopsis: "物理系学霸顾未易意外住进了邻家女孩司徒末的家，两个截然不同的人开始了鸡飞狗跳的同居生活。从互相嫌弃到彼此依赖，一段清爽甜蜜的大学爱情悄然生长。",
    highlights: [
      "清爽治愈的大学同居喜剧",
      "学霸与文科女的反差萌",
      "轻松明快的青春甜宠氛围",
    ],
    tags: ["青春", "甜宠", "校园"],
  },
  {
    id: "mv-028",
    title: "你好，旧时光",
    type: "电视剧",
    category: "青春校园",
    region: "中国",
    year: 2017,
    director: "沙漠",
    actors: ["李兰迪", "张新成", "周澄奥"],
    episodes: 30,
    rating: 8.8,
    views: 2180,
    updateStatus: "已完结",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20poster%20of%20an%20old%20chinese%20courtyard%20alley%20at%20warm%20pink%20sunset%20with%20laundry%20lines%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20palette%2C%20nostalgic%20editorial%20mood&width=400&height=600&seq=love-cv-28&orientation=portrait",
    synopsis: "在振华中学的旧时光里，乖乖女余周周和“小太阳”林杨一起长大。友情、亲情与懵懂的爱情交织在高中的每一天。多年以后再回首，那段旧时光依然闪闪发亮。",
    highlights: [
      "最温暖的青春群像记忆",
      "余周周与林杨的青梅竹马",
      "细腻动人的成长与陪伴",
    ],
    tags: ["青春", "成长", "群像"],
  },
];

export const heroSlides = [
  {
    id: "hero-1",
    movieId: "mv-001",
    title: "春日暖阳",
    subtitle: "都市情感 · 2024 热播",
    desc: "梧桐街樱花树下，一段治愈了彼此过往的慢节奏爱情正在升温。",
    image: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20cinematic%20banner%20with%20soft%20pink%20cherry%20blossoms%20drifting%20in%20warm%20golden%20sunlight%20over%20a%20quiet%20old%20street%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20and%20cream%20palette%2C%20high%20detail&width=1600&height=700&seq=love-hero-01&orientation=landscape",
  },
  {
    id: "hero-2",
    movieId: "mv-013",
    title: "爱的迫降",
    subtitle: "海外情感 · 口碑佳作",
    desc: "一场滑翔伞意外，让跨越界限的守护式爱情悄然降临。",
    image: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20cinematic%20banner%20of%20misty%20green%20mountains%20with%20soft%20pink%20dawn%20sky%20and%20gentle%20fog%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20and%20cream%20palette%2C%20high%20detail&width=1600&height=700&seq=love-hero-02&orientation=landscape",
  },
  {
    id: "hero-3",
    movieId: "mv-008",
    title: "情书",
    subtitle: "经典重映 · 日影",
    desc: "一封寄往天国的信，揭开了被时光尘封的青春暗恋。",
    image: "https://readdy.ai/api/search-image?query=Romantic%20artistic%20cinematic%20banner%20of%20a%20snowy%20mountain%20town%20at%20soft%20pink%20dawn%20with%20gentle%20falling%20snow%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20and%20cream%20palette%2C%20high%20detail&width=1600&height=700&seq=love-hero-03&orientation=landscape",
  },
];

export const categoryEntries = [
  {
    key: "电视剧",
    name: "电视剧",
    slogan: "多彩爱情故事，陪伴你的每个夜晚",
    desc: "都市情感、青春校园、古装情缘与海外佳剧，一网打尽。",
    image: "https://readdy.ai/api/search-image?query=Warm%20romantic%20illustration%20of%20a%20cozy%20living%20room%20with%20tv%20glow%20and%20soft%20pink%20evening%20light%2C%20minimal%20artistic%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20and%20cream%20palette%2C%20high%20detail&width=800&height=600&seq=love-cat-tv&orientation=landscape",
  },
  {
    key: "电影",
    name: "电影",
    slogan: "一帧光影，一段心动",
    desc: "经典与热映爱情电影，用两小时讲完一场心动。",
    image: "https://readdy.ai/api/search-image?query=Warm%20romantic%20illustration%20of%20a%20vintage%20cinema%20seat%20with%20soft%20pink%20projector%20light%20beams%2C%20minimal%20artistic%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20and%20cream%20palette%2C%20high%20detail&width=800&height=600&seq=love-cat-movie&orientation=landscape",
  },
];

export const subCategories = ["爱情片", "都市情感", "古装情缘", "青春校园", "海外情感"];